import { GET_VERSIONS, NAVIGATION } from '../types';
import { error, success } from '../utils';

export let initialState = {
  getVersions: {
    isLoading: false,
    isError: false,
  },
  projectName: null,
  versions: [],
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case GET_VERSIONS:
      return {
        ...state,
        getVersions: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_VERSIONS):
      return {
        ...state,
        getVersions: {
          isLoading: false,
          isError: false,
        },
        projectName: action.payload.data.projectName,
        versions: action.payload.data.versions,
      };
    case error(GET_VERSIONS):
      return {
        ...state,
        getVersions: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
